import { RiStarSFill, RiStarSLine } from 'react-icons/ri';
//skills stars
const createStars = (number) => {
    let stars = []
   
      if (stars.length < 5){
       for (let i = 0; i < number; i++) {
         stars.push(<RiStarSFill key={i} className="h-6 hidden lg:flex lg:max-w-[482px] mx-auto"/>)
       }
        for (let i = 0; i < 5 - number; i++) {
        stars.push(<RiStarSLine key={i+number} className="h-6 hidden lg:flex lg:max-w-[482px] mx-auto"/>)
        }
      }

    return stars;
  }

export default createStars;